import { ReactChild } from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

export const KnightColors = {
  Blue: '#122CB1',
  Green: '#227A45',
  Orange: '#E19B5C',

  TextBrown: '#683100',
  Paper: '#EBCEA5',

  White: '#FFF',
  LightGrey: '#9B9B9B',
  DarkGrey: '#DADADA',
  Black: '#000',
}

export const theme = createTheme({
  // mixins: {},
  breakpoints: {
    values: {
      xs: 0,
      sm: 428, // default 600
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'ugly' },
          style: {
            textTransform: 'none',
            boxShadow: `0 4px 4px rgba(0, 0, 0, 0.25)`,
            borderRadius: 16,
            fontSize: 14,
            lineHeight: `20px`,
            height: 32,
            padding: `6px 12px`,
            '& .MuiButton-startIcon': {
              marginRight: 2,
            },
          },
        },
        {
          props: { variant: 'ugly', color: 'success' },
          style: {
            backgroundColor: KnightColors.Green,
            color: KnightColors.White,
            '&:hover': {
              backgroundColor: KnightColors.Green,
              boxShadow: `0 6px 12px rgba(0, 0, 0, 0.4)`,
            },
          },
        },
        {
          props: { variant: 'ugly', color: 'primary' },
          style: {
            backgroundColor: KnightColors.Blue,
            color: KnightColors.White,
            '&:hover': {
              backgroundColor: KnightColors.Blue,
              boxShadow: `0 6px 12px rgba(0, 0, 0, 0.4)`,
            },
          },
        },
        {
          props: { variant: 'ugly', disabled: true },
          style: {
            backgroundColor: KnightColors.DarkGrey,
            color: KnightColors.LightGrey,
            boxShadow: 'none',
          },
        },
        {
          props: { variant: 'ugly', disabled: true, color: 'warning' },
          style: {
            backgroundColor: KnightColors.Orange,
            boxShadow: `inset 0px 4px 4px rgba(0, 0, 0, 0.25)`,
            '&.Mui-disabled': {
              color: KnightColors.White,
            },
          },
        },
      ],
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: `'Orbitron', sans-serif`,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: 12,
          lineHeight: 16/12,
        },
      },
    },
  },
  palette: {
    // primary: {
    //   light: '#B566FD',
    //   main: '#5A4BF2',
    //   dark: '#413086',
    //   // dark: '',
    //   // contrastText: ''
    // },
    primary: {
      main: KnightColors.Blue,
    },
    // secondary: {
    //   main: '',
    // },
    success: {
      main: KnightColors.Green,
    },
    error: {
      light: '#D3252F',
      main: '#9A0F01',
      dark: '#830D02',
    },
    warning: {
      light: '#F6DFBA',
      main: '#FFC611',
      dark: '#8D622B',
      contrastText: '#FFF',
    },
    info: {
      main: '#73c3ef',
      dark: '#46b5f6',
    },

    // success?: PaletteColorOptions;
    // mode?: PaletteMode;
    // tonalOffset?: PaletteTonalOffset;
    // contrastThreshold?: number;
    // common?: Partial<CommonColors>;
    // grey?: ColorPartial;
    // text?: Partial<TypeText>;
    // divider?: string;
    // action?: Partial<TypeAction>;
    background: {
      default: KnightColors.Orange,
      // paper: '',
    },
    // getContrastText?: (background: string) => string;
  },
  // shadows: ,
  transitions: {},
  typography: {
    fontFamily: 'Open Sans, sans-serif',
    // h1: {
    //   fontSize: 28,
    //   color: '#000',
    //   textShadow: `0 1px #868cc0`,
    // },

    HeaderUI: {
      color: KnightColors.White,
      fontSize: 20,
    },

    CashbackTableHeader: {
      color: KnightColors.TextBrown,
      fontFamily: 'Open Sans, sans-serif',
      fontStyle: 'normal',
      fontSize: 14,
      fontWeight: 700,
      lineHeight: `20px`,
    },

    CashbackTableContent: {
      color: KnightColors.TextBrown,
      fontFamily: 'Open Sans, sans-serif',
      fontStyle: 'normal',
      fontSize: 12,
      fontWeight: 600,
      lineHeight: `20px`,
    },

    CashbackStatisticsHeader: {
      color: KnightColors.Black,
      fontFamily: 'Open Sans, sans-serif',
      fontStyle: 'normal',
      fontSize: 16,
      fontWeight: 600,
      lineHeight: `22px`,
    },

    CashbackStatisticsSubject: {
      color: KnightColors.Black,
      fontFamily: 'Open Sans, sans-serif',
      fontStyle: 'normal',
      fontSize: 16,
      fontWeight: 400,
      lineHeight: `22px`,
      paddingLeft: 4,
    },

    CashbackStatisticsContent: {
      color: KnightColors.TextBrown,
      fontFamily: 'Open Sans, sans-serif',
      fontStyle: 'normal',
      fontSize: 16,
      fontWeight: 600,
      lineHeight: `22px`,
    },

    KnightsTableHeader: {
      color: KnightColors.TextBrown,
      fontSize: 14,
      fontWeight: 700,
      lineHeight: '19px',
    },

    KnightsTableCell: {
      color: KnightColors.TextBrown,
      fontSize: 12,
      fontWeight: 600,
      lineHeight: 16/12,
    },

    UglyDialogTitle: {
      color: KnightColors.TextBrown,
      fontFamily: 'Open Sans, sans-serif',
      fontSize: 24,
      fontWeight: 600,
      lineHeight: 1,
    },

    UglyDialogInnerSubject: {
      color: KnightColors.Black,
      fontFamily: 'Open Sans, sans-serif',
      fontSize: 16,
      fontWeight: 600,
      lineHeight: 22 / 16,
    },
    UglyDialogInnerText: {
      color: KnightColors.Black,
      fontFamily: 'Open Sans, sans-serif',
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 22 / 16,
    },
    UglyDialogInnerHint: {
      color: KnightColors.Black,
      fontFamily: 'Open Sans, sans-serif',
      fontSize: 12,
      fontWeight: 400,
      lineHeight: 16 / 12,
    },

    FightPanel: {
      color: KnightColors.TextBrown,
      fontFamily: 'Open Sans, sans-serif',
      fontSize: 20,
      fontWeight: 600,
      lineHeight: 1.4,
    },
    FightButton: {
      color: KnightColors.White,
      fontFamily: 'Inknut Antiqua, serif',
      fontSize: 12,
      fontWeight: 800,
      lineHeight: 2,
      paddingLeft: 12,
      paddingRight: 12,
      borderRadius: 10,
      border: `1px solid #FFF`,
      display: 'block',
      background: `linear-gradient(180deg, #B465FD 0%, #5D4BF3 100%)`,
      boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
      opacity: .95,
      whiteSpace: 'nowrap',
    },

    balance: {
      fontFamily: `"JetBrains Mono", monospace`,
      fontWeight: 300,
      fontSize: 14,
      lineHeight: 1.5,
      color: '#000',
      whiteSpace: 'nowrap',
      textShadow: `
        -1px  1px #FFF8,
         1px -1px #F5F6,
         1px  1px #FF49,
        -1px -1px #6FF9
      `
    },
  },
  zIndex: {},
})

export default function MuiThemeProvider({ children }: { children: ReactChild }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      { children }
    </ThemeProvider>
  )
}
